import { useActivateDeliveryLocationMutation, useCreateDeliveryLocationMutation, useDeleteDeliveryLocationMutation, useGetDeliveryLocationsByContractQuery, useUpdateDeliveryLocationMutation, } from '../services/benefitApi';
import { useBenefitContract } from './useBenefitContract';
export function useBenefitContractLocation() {
    const { contractData } = useBenefitContract();
    const location = contractData?.deliveryLocation || null;
    const voucherContractId = contractData?.id;
    const { data: locations = [], isLoading: isDeliveryLocationsLoading, isFetching: isDeliveryLocationsFetching, isError: isDeliveryLocationsError, } = useGetDeliveryLocationsByContractQuery({
        voucherContractId: voucherContractId,
    }, {
        skip: !voucherContractId,
    });
    const [createDeliveryLocationMutation, { isLoading: isCreating }] = useCreateDeliveryLocationMutation();
    const [updateDeliveryLocationMutation, { isLoading: isUpdating }] = useUpdateDeliveryLocationMutation();
    const [deleteDeliveryLocationMutation, { isLoading: isDeleting, isError: isDeleteError }] = useDeleteDeliveryLocationMutation();
    const [activateDeliveryLocationMutation, { isLoading: isActivating, isError: isActivateError }] = useActivateDeliveryLocationMutation();
    const handleCreateDeliveryLocation = async (body) => {
        if (!voucherContractId) {
            throw new Error('Voucher contract ID is required');
        }
        const result = await createDeliveryLocationMutation({
            voucherContractId,
            body,
        }).unwrap();
        return result;
    };
    const handleUpdateDeliveryLocation = async (deliveryLocationId, body) => {
        if (!voucherContractId) {
            throw new Error('Voucher contract ID is required');
        }
        const result = await updateDeliveryLocationMutation({
            voucherContractId,
            deliveryLocationId,
            body,
        }).unwrap();
        return result;
    };
    const handleDeleteDeliveryLocation = async (deliveryLocationId) => {
        if (!voucherContractId) {
            throw new Error('Voucher contract ID is required');
        }
        await deleteDeliveryLocationMutation({
            voucherContractId,
            deliveryLocationId,
        }).unwrap();
    };
    const handleActivateDeliveryLocation = async (deliveryLocationId) => {
        if (!voucherContractId) {
            throw new Error('Voucher contract ID is required');
        }
        await activateDeliveryLocationMutation({
            voucherContractId,
            deliveryLocationId,
        }).unwrap();
    };
    return {
        location,
        locations,
        isLoading: isDeliveryLocationsLoading || isDeliveryLocationsFetching,
        isError: isDeliveryLocationsError,
        createDeliveryLocation: handleCreateDeliveryLocation,
        updateDeliveryLocation: handleUpdateDeliveryLocation,
        deleteDeliveryLocation: handleDeleteDeliveryLocation,
        activateDeliveryLocation: handleActivateDeliveryLocation,
        isCreating,
        isUpdating,
        isDeleting,
        isDeleteError,
        isActivating,
        isActivateError,
    };
}
